module.exports = __webpack_public_path__ + "static/media/badge-app-store-rounded.af293180.png";